import { Pagination } from "@egaranti/components";

import { useTranslation } from "react-i18next";

import ProductCard from "./ProductCard";

import EmptyTable from "@/components/shared/EmptyTable";

const ProductList = ({
  products,
  pagination,
  onPageChange,
  onDeleteProduct,
  onEditWarrantyDate,
  onUploadBill,
}) => {
  const { t } = useTranslation();

  return (
    <div className="formBox w-full">
      <h2 className="mb-5 text-lg font-medium">{t("clientsPage.products")}</h2>
      {products.length ? (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onDelete={onDeleteProduct}
              onEditWarrantyDate={onEditWarrantyDate}
              onUploadBill={onUploadBill}
            />
          ))}
        </div>
      ) : (
        <EmptyTable
          title={t("clientsPage.clientCouldNotFound")}
          desc={t("clientsPage.clientCouldNotFoundDesc")}
        />
      )}

      <div className="mt-4">
        <Pagination
          totalPages={pagination?.totalPages}
          currentPage={pagination?.page}
          pageSize={pagination?.size}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default ProductList;
